import {resolveBackground} from '#core/utils/color-utils.js';

import {generateBorder} from '#core/application/modules/tiles/border/index.js';

export function cardsAndPromotionsFactory(PALETTE) {
    return {
        BaseEventCard: {
            container: {
                style: {
                    height: '182px',
                    ...resolveBackground(PALETTE.CARD_CONTAINER_BG),
                    ...generateBorder(PALETTE.CARD_BORDER),
                },
            },
            clickableArea: {
                style: {
                    base: {
                        height: '100%',
                    },
                },
            },
        },
        SportWatermarkImage: {
            sportIcon: {
                icon: {
                    style: {
                        fill: PALETTE.CARD_WATERMARK_ICON_COLOR,
                        opacity: PALETTE.CARD_WATERMARK_ICON_OPACITY,
                    },
                },
            },
        },
        ...(PALETTE.CARD_BORDER.BORDER_SHOW_SHADOW
            ? {
                  EventCardsCarousel: {
                      swiper: {
                          style: {
                              // Add space for inner cards shadow
                              padding: '5px 1px 10px',
                              _mobile_padding: '5px 8px 10px',
                          },
                      },
                  },
                  PrebuiltBets: {
                      swiper: {
                          style: {
                              // Add space for inner cards shadow
                              padding: '5px 1px 10px',
                              _mobile_padding: '5px 8px 10px',
                          },
                      },
                  },
              }
            : {}),
    };
}
